export const uk = {
    'add-minus-phrases': 'Добавить минус-фразы',
    'add-phrases': 'Добавить фразы',
    'add-phrases-to-group': 'Добавить к группе обьявлений',
    'add-to-start': 'Добавить в стартовые',
    'chosen-phrases': 'Выбранные фразы',
    'chosen-phrases-empty-header': 'Добавьте выбранное к группе',
    'chosen-phrases-empty-text': 'Здесь будет список ключевых фраз, которые можно добавить к группе объявлений',
    'minus-phrases': 'Минус-фразы',
    'minus-phrases-empty-header': 'Добавьте выбранное к группе',
    'minus-phrases-empty-text': 'Здесь будет список минус-фраз, которые можно добавить к группе объявлений',
    'minus-words': 'Минус-слова',
    'phrase-selection': 'Подбор фраз',
    phrases: 'Фразы',
    'phrases-input-placeholder': 'Введите запросы через запятую или с помощью оператора ( | )',
    'search-also-phrases-empty-header': 'Не заданы стартовые запросы',
    'search-also-phrases-empty-text': 'Здесь будут похожие запросы для стартовых запросов, выбранных в левой колонке',
    'search-also-phrases-not-exist-header': 'Нет похожих запросов',
    'search-also-phrases-not-exist-text': 'Измените стартовый запрос в левой колонке',
    'searched-also': 'Похожие',
    'searched-also-phrases': 'Похожие запросы',
    'searched-with': 'Вложенные',
    'shows-per-month': 'Показов в месяц',
    'similar-phrases-empty-header': 'Не заданы стартовые запросы',
    'similar-phrases-empty-text': 'Здесь будут вложенные запросы для стартовых запросов, выбранных в левой колонке',
    'similar-phrases-not-exist-header': 'Нет вложенных запросов',
    'similar-phrases-not-exist-text': 'Измените стартовый запрос в левой колонке',
    'start-phrases': 'Стартовые запросы',
    'start-phrases-empty-header': 'Не заданы запросы',
    'start-phrases-empty-text': 'Введите запросы через запятую'
};
